<template>
	<div class="profile-selection-container width-100 height-100 mt-3">
		<div class="profile-selection-title">
			<v-btn v-if="!noBackButton" @click="removeActionFromSelectedNode" class="back-button" width="25" height="25" fab x-small>
				<AppIcon name="back" />
			</v-btn>
			Set up step
		</div>
		<ProfileSelectionMenu
			showLockedIndication
			:serviceId="node.service"
			:secondaryTitle="secondaryTitle"
			:configurationId="configurationId"
			:serviceVersionId="node.service_version"
			:profileId="node.credentials_configuration.credentials"
			:credentialsType="node.credentials_configuration.credentials_type"
			:sourceFieldUUID="node.credentials_configuration.source_field_uuid"
			:hasEditPermissions="hasEditPermissions"
		/>
		<AdvancedSettings class="mt-6" />
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { editNode } from '@/store/modules/selectedNode/getters';
import AdvancedSettings from './ProfileSelection/AdvancedSettings';
import { actionChanged } from '@/store/modules/selectedNode/actions';
import ProfileSelectionMenu from './ProfileSelection/ProfileSelectionMenu';
import { CredentialsTypes } from '@ply-io/ply-front-shared-utilities';
import { userSpecificConfigurationId, generalConfigurationId } from '@/store/modules/selectedWorkflow/modules/configurations/getters';
import { getService } from '@/store/modules/apps/getters';
import AppService from '@/utils/AppService';
import { canEditWorkflow } from '@/store/modules/workflows/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
export default {
	name: 'ProfileSelection',
	props: {
		noBackButton: { type: Boolean },
		isSelectionForContextualData: { type: Boolean },
	},
	components: {
		AdvancedSettings,
		ProfileSelectionMenu,
	},
	computed: {
		...mapGetters([editNode.fullPath, generalConfigurationId.fullPath, userSpecificConfigurationId.fullPath, getService.fullPath]),
		...mapGettersShorthand({ canEditWorkflow }),
		node() {
			return this[editNode.fullPath];
		},
		configurationId() {
			return this.node?.credentials_configuration?.credentials_type === CredentialsTypes.ProfileBased
				? this[userSpecificConfigurationId.fullPath]
				: this[generalConfigurationId.fullPath]; // CredentialsTypes.AccountBased
		},
		secondaryTitle() {
			let title = '';
			if (this.isSelectionForContextualData && AppService.doesAppSupportAccountWorkspaces(this.service)) {
				const workspaceResourceTitle = AppService.getServiceWorkspaceResourceTitle(this.service);
				title += `Also affects which ${workspaceResourceTitle} this add-on is displayed on`;
			}
			return title;
		},
		service() {
			return this[getService.fullPath](this.node.service);
		},
		hasEditPermissions() {
			return this.canEditWorkflow(this.node.workflow);
		},
	},
	methods: {
		...mapActions([actionChanged.fullPath]),
		removeActionFromSelectedNode() {
			const newNode = { ...this.node, action: null };
			this[actionChanged.fullPath]({ node: newNode });
		},
	},
};
</script>

<style scoped lang="scss">
$side-padding: 20px;
.profile-selection-container {
	color: var(--bold-title);
	padding: 0px $side-padding;

	.profile-selection-title {
		font-size: 16px;
		font-weight: bold;
	}
	.back-button {
		margin-right: 5px;
		border-radius: 6px;
		border: 1px solid var(--grey-background);
	}
}
</style>
